module.exports = __webpack_public_path__ + "media/images/flags/tn-6cd8c9a453cd0fc5e7619a480e957d2d.svg";